// @ts-nocheck
import * as React from "react";
import classNames from "classnames";
import Stack from "molecules/stack/stack";
import StackItem from "molecules/stackItem/stackItem";
import Button from "atoms/button/button";
import Icon from "atoms/icons/icon";
import Label from "atoms/label/label";
import BodyText from "atoms/bodyText/bodyText";
import { Typography } from "antd";
import Sheet from "atoms/sheet/sheet";
import SheetBody from "atoms/sheet/sheetBody/sheetBody";
import * as constants from "../../home/constants";
import {
  formatDate,
  formatMoney,
  formatPercentage,
  formatThousands,
} from "utils/utilities";
import Card from "atoms/card/card";

const { Title, Text } = Typography;

const AppSettingMenu: React.FunctionComponent<Props> = (props: Props) => {
  const {
    title,
    description,
    buttonText,
    handleButtonClick,
    itemIdentifier,
    count,
  } = props;

  const handleMasterDataButtonClick = () => {
    handleButtonClick(itemIdentifier);
  };
  return (
    // <Sheet isPage className="dashboard-page">
    //   <SheetBody>
    //     <Stack className="dashboard-card-wrapper">
    // <div className="w-100" onClick={handleMasterDataButtonClick}>
    <StackItem
      className="dashboard-card-block pointer"
      handleClick={handleMasterDataButtonClick}
    >
      <Card>
        <Stack className="card-info">
          <Title level={3}>{title}</Title>
          <Title level={5}>{description}</Title>
          <Title level={2}>{count}</Title>
        </Stack>
      </Card>
    </StackItem>
    // </div>
    //     </Stack>
    //   </SheetBody>
    // </Sheet>
  );
};
export default AppSettingMenu;
